<template>
  <!-- 处理记录弹窗 -->
  <a-modal
    :title="`处理记录 - 工单ID: ${complaintId || ''}`"
    :visible="visible"
    @cancel="handleClose"
    :width="1200"
    :footer="null"
  >
    <!-- 条件搜索区域 -->
    <div class="table-page-search-wrapper" style="margin-bottom: 16px">
      <a-form layout="inline">
        <a-row :gutter="48" type="flex" justify="space-between" align="middle">
          <a-col :flex="'1 1 auto'" style="display: flex; gap: 48px;">
            <!-- 状态筛选 -->
            <div style="flex: 1;">
              <a-form-item label="状态">
                <a-select
                  v-model:value="queryParam.handleStatus"
                  placeholder="请选择"
                  allow-clear
                  style="width: 100%"
                  class="no-border-radius-select"
                >
                  <a-select-option
                    v-for="dict in dict.type['handle_status']"
                    :key="dict.value"
                    :value="dict.value"
                  >
                    {{ dict.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <!-- 处理人筛选 -->
            <div style="flex: 1;">
              <a-form-item label="处理人">
                <a-input
                  v-model:value="queryParam.handleName"
                  placeholder="请输入"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </div>
          </a-col>

          <!-- 按钮区域：收起状态时在右侧 -->
          <a-col v-if="!advanced" :flex="'0 0 auto'">
            <a-form-item :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }">
              <span
                class="table-page-search-submitButtons"
                :style="submitButtonStyle"
              >
                <a-button type="primary" @click="handleQuery" class="search-button"
                  >查询</a-button
                >
                <a-button style="margin-left: 8px" @click="handleReset" class="no-border-button"
                  >重置</a-button
                >
                <a-button style="margin-left: 8px" @click="toggleAdvanced" class="no-border-button toggle-button">
                  {{ advanced ? '收起' : '展开' }}
                  <UpOutlined v-if="advanced" />
                  <DownOutlined v-else />
                </a-button>
              </span>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <!-- 处理时间筛选 -->
            <a-col :md="8" :sm="24">
              <a-form-item label="处理时间">
                <a-date-picker
                  v-model:value="queryParam.handleTime"
                  style="width: 100%"
                  format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD"
                  placeholder="请选择"
                  allow-clear
                  class="no-border-radius-picker"
                />
              </a-form-item>
            </a-col>
            <!-- 处理方式筛选 -->
            <a-col :md="8" :sm="24">
              <a-form-item label="处理方式">
                <a-select
                  v-model:value="queryParam.handleMethod"
                  placeholder="请选择"
                  allow-clear
                  style="width: 100%"
                  class="no-border-radius-select"
                >
                  <a-select-option
                    v-for="dict in dict.type['handle_method']"
                    :key="dict.value"
                    :value="dict.value"
                  >
                    {{ dict.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- 情况描述筛选 -->
            <a-col :md="8" :sm="24">
              <a-form-item label="情况描述">
                <a-input
                  v-model:value="queryParam.remark"
                  placeholder="请输入"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </a-col>
            <!-- 处理完成时间筛选 -->
            <a-col :md="8" :sm="24">
              <a-form-item label="处理完成时间">
                <a-date-picker
                  v-model:value="queryParam.confirmTime"
                  style="width: 100%"
                  format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD"
                  placeholder="请选择"
                  allow-clear
                  class="no-border-radius-picker"
                />
              </a-form-item>
            </a-col>
            <!-- 第二行空位 -->
            <a-col :md="8" :sm="24"></a-col>
            <a-col :md="8" :sm="24"></a-col>

            <!-- 展开后，按钮在第三行第三个a-col，左对齐 -->
            <a-col :md="8" :sm="24"></a-col>
            <a-col :md="8" :sm="24"></a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }">
                <span
                  class="table-page-search-submitButtons"
                  :style="submitButtonStyle"
                >
                  <a-button type="primary" @click="handleQuery" class="search-button"
                    >查询</a-button
                  >
                  <a-button style="margin-left: 8px" @click="handleReset" class="no-border-button"
                    >重置</a-button
                  >
                  <a-button style="margin-left: 8px" @click="toggleAdvanced" class="no-border-button toggle-button">
                    {{ advanced ? '收起' : '展开' }}
                    <UpOutlined v-if="advanced" />
                    <DownOutlined v-else />
                  </a-button>
                </span>
              </a-form-item>
            </a-col>
          </template>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operations" style="margin-bottom: 16px">
      <a-button
        type="text"
        shape="circle"
        @click="handleRefresh"
        v-hasPermi="refreshPermission"
        class="refresh-icon-button"
      >
        <img src="@/assets/images/projectUser/refresh.png" alt="刷新" />
      </a-button>
      <a-button
        @click="handleExport"
        :disabled="!list || list.length === 0 || pagination.total === 0"
        v-hasPermi="exportPermission"
        class="no-border-button"
      >
        <UploadOutlined />导出
      </a-button>
    </div>

    <!-- 详情组件 -->
    <ComplaintHandleDetail
      :visible="detailVisible"
      :handle-id="currentHandleId"
      @close="handleDetailClose"
    />
    <!-- 数据表格 -->
    <div v-if="list && list.length > 0">
      <a-table
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :loading="loading"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
          fixed: true,
        }"
        rowKey="id"
        :scroll="{ x: true }"
        size="small"
        class="optimized-table"
        @change="handleTableChange"
      >
        <!-- 使用 bodyCell 插槽自定义单元格显示 -->
        <template #bodyCell="{ column, text, record, index }">
          <!-- 序号列：计算显示序号 -->
          <template v-if="column.dataIndex === 'id'">
            <span>
              {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
            </span>
          </template>
          <!-- 状态列：使用字典标签显示 -->
          <template v-else-if="column.dataIndex === 'handleStatus'">
            <span>
              <dict-tag :options="dict.type['handle_status']" :value="record.handleStatus" />
            </span>
          </template>
          <!-- 处理人列：显示处理人名称或ID -->
          <template v-else-if="column.dataIndex === 'handleName'">
            <span>
              {{ record.handleName || record.handleId || '-' }}
            </span>
          </template>
          <!-- 处理方式列：使用字典标签显示 -->
          <template v-else-if="column.dataIndex === 'handleMethod'">
            <span>
              <dict-tag :options="dict.type['handle_method']" :value="record.handleMethod" />
            </span>
          </template>
          <!-- 处理时间列：格式化显示 -->
          <template v-else-if="column.dataIndex === 'handleTime'">
            <span>
              {{ parseTime(record.handleTime) }}
            </span>
          </template>
          <!-- 处理完成时间列：格式化显示 -->
          <template v-else-if="column.dataIndex === 'confirmTime'">
            <span>
              {{ parseTime(record.confirmTime) }}
            </span>
          </template>
          <!-- 操作列 -->
          <template v-else-if="column.dataIndex === 'operation'">
            <span>
              <a-divider type="vertical" v-hasPermi="detailPermission" />
              <a @click="handleViewDetail(record)" v-hasPermi="detailPermission">
                查看详情
              </a>
            </span>
          </template>
          <!-- 其他字段：默认显示 text 值 -->
          <template v-else>
            <span>{{ text }}</span>
          </template>
        </template>
      </a-table>
    </div>
    <!-- 空数据提示 -->
    <a-empty v-else description="暂无处理记录数据" style="padding: 60px 0" />
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
/**
 * 投诉工单处理记录组件
 * 功能：显示指定投诉工单的处理记录
 * - 支持按处理时间、处理方式、方式类型筛选记录
 * - 支持分页查询和刷新
 * - 支持导出记录数据
 * - 通过props接收投诉工单ID
 */
import { pageComplaintHandle } from '@/api/system/complaintHandle'
import { tableMixin } from '@/store/table-mixin'
import { parseTime as formatTime } from '@/utils/ruoyi'
import ComplaintHandleDetail from './ComplaintHandleDetail'
import {
  SearchOutlined,
  RedoOutlined,
  UpOutlined,
  DownOutlined,
  UploadOutlined,
} from '@ant-design/icons-vue'

export default {
  name: 'ComplaintHandleLog',
  dicts: ['handle_method', 'handle_status'],
  mixins: [tableMixin],
  components: {
    ComplaintHandleDetail,
    SearchOutlined,
    RedoOutlined,
    UpOutlined,
    DownOutlined,
    UploadOutlined,
  },
  props: {
    // 弹窗显示/隐藏状态
    visible: {
      type: Boolean,
      default: false,
    },
    // 投诉工单ID（必填）
    complaintId: {
      type: Number,
      default: null,
    },
    // 权限前缀，用于动态生成权限值
    permissionPrefix: {
      type: String,
      default: 'system:complaintHandle',
    },
  },
  data() {
    return {
      // 记录列表数据
      list: [],
      // 加载状态
      loading: false,
      // 选中的行key数组
      selectedRowKeys: [],
      // 选中的行数据数组
      selectedRows: [],
      // 详情弹窗显示状态
      detailVisible: false,
      // 当前查看详情的处理记录ID
      currentHandleId: null,
      // 高级搜索展开/收起状态
      advanced: false,
      // 查询参数（与表格字段顺序一致）
      queryParam: {
        handleStatus: undefined, // 状态
        handleName: undefined, // 处理人
        handleTime: null, // 处理时间
        handleMethod: undefined, // 处理方式
        remark: undefined, // 情况描述
        confirmTime: null, // 处理完成时间
      },
      // 分页配置
      pagination: {
        current: 1, // 当前页码
        pageSize: 10, // 每页条数
        total: 0, // 总条数
        showSizeChanger: true, // 显示每页条数选择器
        showQuickJumper: true, // 显示快速跳转
        showTotal: (total) => `共 ${total} 条`, // 显示总数
      },
      // 表格列配置
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          align: 'center',
          width: 80,
        },
        {
          title: '状态',
          dataIndex: 'handleStatus',
          align: 'center',
          width: 100,
        },
        {
          title: '处理人',
          dataIndex: 'handleName',
          align: 'center',
          width: 120,
        },
        {
          title: '处理时间',
          dataIndex: 'handleTime',
          align: 'center',
          width: 180,
        },
        {
          title: '处理方式',
          dataIndex: 'handleMethod',
          align: 'center',
          width: 120,
        },
        {
          title: '情况描述',
          dataIndex: 'remark',
          align: 'center',
          ellipsis: true,
          width: 200,
        },
        {
          title: '处理完成时间',
          dataIndex: 'confirmTime',
          align: 'center',
          width: 180,
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 200,
          align: 'center',
          fixed: 'right',
        },
      ],
    }
  },
  computed: {
    /**
     * 刷新权限
     * 根据权限前缀动态生成刷新权限值
     */
    refreshPermission() {
      return [`${this.permissionPrefix}:refresh`]
    },
    /**
     * 导出权限
     * 根据权限前缀动态生成导出权限值
     */
    exportPermission() {
      return [`${this.permissionPrefix}:export`]
    },
    /**
     * 查看详情
     * 根据权限前缀动态生成导出权限值
     */
    detailPermission() {
      return [`${this.permissionPrefix}:detail`]
    },
    /**
     * 提交按钮样式
     */
    submitButtonStyle() {
      return {}
    },
  },
  watch: {
    /**
     * 监听弹窗显示状态
     * 当弹窗打开且投诉工单ID存在时，初始化数据
     */
    visible(newVal) {
      if (newVal && this.complaintId) {
        this.init()
      }
    },
    /**
     * 监听投诉工单ID变化
     * 当投诉工单ID变化且弹窗打开时，重新初始化数据
     */
    complaintId(newVal) {
      if (newVal && this.visible) {
        this.init()
      }
    },
  },
  methods: {
    /**
     * 初始化数据
     * 重置分页、清空列表、重置查询条件，然后获取记录列表
     */
    init() {
      // 重置分页到第一页
      this.pagination.current = 1
      this.pagination.total = 0
      // 清空列表数据
      this.list = []
      // 清空选中状态
      this.selectedRowKeys = []
      this.selectedRows = []
      // 重置展开状态
      this.advanced = false
      // 重置查询条件（与表格字段顺序一致）
      this.queryParam = {
        handleStatus: undefined, // 状态
        handleName: undefined, // 处理人
        handleTime: null, // 处理时间
        handleMethod: undefined, // 处理方式
        remark: undefined, // 情况描述
        confirmTime: null, // 处理完成时间
      }
      // 获取记录列表
      this.getList()
    },

    /**
     * 获取处理记录列表
     * 根据投诉工单ID和查询条件分页查询记录数据
     */
    getList() {
      // 校验投诉工单ID
      if (!this.complaintId) {
        this.$message.warning('投诉工单ID不能为空', 3)
        return
      }

      // 开始加载
      this.loading = true

      // 构建请求参数（与表格字段顺序一致）
      const params = {
        complaintId: this.complaintId, // 投诉工单ID
        pageNum: this.pagination.current, // 当前页码
        pageSize: this.pagination.pageSize, // 每页条数
        handleStatus: this.queryParam.handleStatus, // 状态
        handleName: this.queryParam.handleName, // 处理人
        handleTime: this.queryParam.handleTime, // 处理时间
        handleMethod: this.queryParam.handleMethod, // 处理方式
        remark: this.queryParam.remark, // 情况说明
        confirmTime: this.queryParam.confirmTime, // 处理完成时间
      }

      // 移除空值参数，避免传递无效参数
      Object.keys(params).forEach((key) => {
        if (
          params[key] === undefined ||
          params[key] === null ||
          params[key] === ''
        ) {
          delete params[key]
        }
      })

      // 发送请求
      pageComplaintHandle(params)
        .then((response) => {
          // 设置列表数据和总数
          this.list = response.data.records || []
          this.pagination.total = response.data.total || 0
          this.loading = false
        })
        .catch(() => {
          // 请求失败，清空数据
          this.loading = false
          this.list = []
          this.pagination.total = 0
        })
    },

    /**
     * 查询操作
     * 重置到第一页并重新获取列表
     */
    handleQuery() {
      this.pagination.current = 1
      this.getList()
    },

    /**
     * 重置查询条件
     * 清空所有查询条件，重置到第一页并重新获取列表
     */
    handleReset() {
      // 重置查询条件（与表格字段顺序一致）
      this.queryParam = {
        handleStatus: undefined, // 状态
        handleName: undefined, // 处理人
        handleTime: null, // 处理时间
        handleMethod: undefined, // 处理方式
        remark: undefined, // 情况描述
        confirmTime: null, // 处理完成时间
      }
      // 重置到第一页
      this.pagination.current = 1
      // 重新获取列表
      this.getList()
    },

    /**
     * 切换高级搜索展开/收起
     */
    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    /**
     * 刷新列表
     * 重新获取当前条件下的记录列表
     */
    handleRefresh() {
      this.getList()
    },

    /**
     * 导出记录数据
     * 如果表格有选择数据，则导出选中的数据；如果没有选择，则导出全部数据
     */
    handleExport() {
      const that = this
      const hasSelection =
        this.selectedRowKeys && this.selectedRowKeys.length > 0
      // 确认对话框
      this.$confirm({
        title: '是否确认导出?',
        content: hasSelection
          ? '将导出所选数据'
          : '将导出当前筛选条件下的全部数据',
        onOk() {
          // 构建导出参数（与表格字段顺序一致）
          const params = {
            complaintId: that.complaintId,
            handleStatus: that.queryParam.handleStatus,
            handleName: that.queryParam.handleName,
            handleTime: that.queryParam.handleTime,
            handleMethod: that.queryParam.handleMethod,
            remark: that.queryParam.remark,
            confirmTime: that.queryParam.confirmTime,
          }
          // 如果选择了数据，则传递选中的ID列表
          if (hasSelection) {
            params.handleIds = that.selectedRowKeys
          }
          // 移除空值参数
          Object.keys(params).forEach((key) => {
            if (
              params[key] === undefined ||
              params[key] === null ||
              params[key] === ''
            ) {
              delete params[key]
            }
          })
          // 下载文件
          that.download(
            'system/complaint-handle/export',
            params,
            `处理记录_工单${that.complaintId}_${new Date().getTime()}.xls`
          )
        },
        onCancel() {},
      })
    },

    /**
     * 关闭弹窗
     * 触发close事件，通知父组件关闭弹窗
     */
    handleClose() {
      $emit(this, 'close')
    },

    /**
     * 查看详情
     * 打开详情弹窗并设置处理记录ID
     * @param {Object} record - 行数据对象
     */
    handleViewDetail(record) {
      if (!record || !record.id) {
        this.$message.warning('处理记录ID不能为空', 3)
        return
      }
      this.currentHandleId = record.id
      this.detailVisible = true
    },

    /**
     * 关闭详情弹窗
     */
    handleDetailClose() {
      this.detailVisible = false
      this.currentHandleId = null
    },

    /**
     * 时间格式化（复用工具函数）
     * @param {String|Date} time - 时间
     * @returns {String} 格式化后的时间字符串
     */
    parseTime(time) {
      return formatTime(time)
    },

    /**
     * 多选变化处理
     * 更新选中的行key和行数据
     * @param {Array} selectedRowKeys - 选中的行key数组
     * @param {Array} selectedRows - 选中的行数据数组
     */
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    /**
     * 表格变化处理
     * 处理分页变化（页码、每页条数）
     * @param {Object} pagination - 分页对象
     */
    handleTableChange(pagination) {
      // 更新分页信息
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      // 分页变化时清空选择
      this.onSelectChange([], [])
      // 重新获取列表
      this.getList()
    },
  },
  emits: ['close'],
}
</script>

<style scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 90px;
  min-width: 90px;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 90px;
  text-align: right;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

.no-border-radius-picker :deep(.ant-picker) {
  border-radius: 0 !important;
}

.no-border-radius-select :deep(.ant-select-selector) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式覆盖 - 优先级高于 no-border-radius-input */
/* 普通输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input) {
  width: 220px !important;
  background: #FFFFFF !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框外层样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  width: 220px !important;
  background: #FFFFFF !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input) {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 日期选择器样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker) {
  width: 220px !important;
  min-width: 220px !important;
  max-width: 220px !important;
  background: #FFFFFF !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 下拉选择框样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  width: 220px !important;
  min-width: 220px !important;
  max-width: 220px !important;
  background: #FFFFFF !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 下拉选择框容器样式 */
.table-page-search-wrapper :deep(.no-border-radius-select.ant-select),
.table-page-search-wrapper :deep(.ant-select) {
  width: 220px !important;
  min-width: 220px !important;
  max-width: 220px !important;
}

.table-page-search-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

/* 按钮区域样式 */
.table-page-search-submitButtons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

/* 确保按钮在页面右侧 */
.table-page-search-wrapper :deep(.ant-row-flex) {
  display: flex;
  width: 100%;
}

.table-page-search-wrapper :deep(.ant-row-flex .ant-col:last-child) {
  margin-left: auto;
}

/* 按钮行右对齐样式 */
.button-form-item-right {
  text-align: right !important;
}

.button-form-item-right :deep(.ant-form-item-control) {
  text-align: right !important;
}

.button-form-item-right :deep(.ant-form-item-control-input) {
  text-align: right !important;
  justify-content: flex-end !important;
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
  background: #F3F3F3 !important;
  color: #101010 !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
  background: #F3F3F3 !important;
  color: #101010 !important;
}

/* 展开/收起按钮文字和图标颜色 */
.toggle-button {
  background: transparent !important;
  color: #165DFF !important;
}

.toggle-button :deep(.anticon) {
  color: #165DFF !important;
}

.toggle-button:hover,
.toggle-button:focus {
  background: transparent !important;
  color: #165DFF !important;
}

.toggle-button:hover :deep(.anticon),
.toggle-button:focus :deep(.anticon) {
  color: #165DFF !important;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.refresh-icon-button img {
  width: 32px;
  height: 32px;
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap; /* 表头不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap; /* 表格内容不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px; /* 增加内边距 */
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 操作列固定右侧样式 */
.optimized-table :deep(.ant-table-tbody > tr > td:last-child) {
  position: sticky;
  right: 0;
  background: white;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 选中行的操作列样式 */
.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected > td:last-child) {
  position: sticky;
  right: 0;
  background: white !important;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td:last-child) {
  position: sticky;
  right: 0;
  background: #f5f5f5 !important;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-thead > tr > th:last-child) {
  position: sticky;
  right: 0;
  background: #fafafa;
  z-index: 11;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 序号列样式优化 */
:deep(.ant-table-tbody > tr > td:first-child) {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #FFFFFF !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

/* 表格复选框列固定左侧样式 */
.optimized-table :deep(.ant-table-thead > tr > th:first-child) {
  position: sticky;
  left: 0;
  background: #fafafa;
  z-index: 12;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr > td:first-child) {
  position: sticky;
  left: 0;
  background: white;
  z-index: 11;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected > td:first-child) {
  position: sticky;
  left: 0;
  background: white !important;
  z-index: 11;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td:first-child) {
  position: sticky;
  left: 0;
  background: #f5f5f5 !important;
  z-index: 11;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 复选框列中的复选框层级 */
.optimized-table :deep(.ant-table-thead > tr > th:first-child .ant-checkbox-wrapper),
.optimized-table :deep(.ant-table-tbody > tr > td:first-child .ant-checkbox-wrapper) {
  position: relative;
  z-index: 13;
}

.optimized-table :deep(.ant-table-thead > tr > th:first-child .ant-checkbox),
.optimized-table :deep(.ant-table-tbody > tr > td:first-child .ant-checkbox) {
  position: relative;
  z-index: 13;
}

.optimized-table :deep(.ant-table-thead > tr > th:first-child .ant-checkbox-inner),
.optimized-table :deep(.ant-table-tbody > tr > td:first-child .ant-checkbox-inner) {
  position: relative;
  z-index: 13;
}

/* 表格分页样式 */
:deep(.ant-pagination) {
  margin-top: 20px;
}

:deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

:deep(.ant-pagination-prev),
:deep(.ant-pagination-next),
:deep(.ant-pagination-prev .ant-pagination-item-link),
:deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 0 !important;
}

:deep(.ant-pagination-prev button),
:deep(.ant-pagination-next button) {
  border-radius: 0 !important;
}

:deep(.ant-pagination-item-active) {
  background: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
}

:deep(.ant-pagination-item-active a) {
  color: #FFFFFF !important;
}

:deep(.ant-pagination-item-active:hover) {
  background: #165DFF !important;
  border-color: #165DFF !important;
}

:deep(.ant-pagination-item-active:hover a) {
  color: #FFFFFF !important;
}

:deep(.ant-pagination-options .ant-input-number) {
  border-radius: 0 !important;
}

:deep(.ant-pagination-options .ant-input-number-input) {
  border-radius: 0 !important;
}

/* 操作列链接样式 */
.optimized-table :deep(.ant-table-tbody > tr > td:last-child a) {
  color: #165DFF !important;
  cursor: pointer;
}

.optimized-table :deep(.ant-table-tbody > tr > td:last-child a:hover) {
  color: #4080ff !important;
}
</style>
